import React, { useEffect, useRef } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import authService from '../../services/authService';
import MarketingRedirect from '../MarketingRedirect/MarketingRedirect';
import { navigateAfterAuth } from '../../utils/postLoginNavigation';
import {
  CUSTOMER_HOME_PATH,
  isPartnersHost,
} from '../../utils/hostNavigation';

const PartnersHomeRedirect: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.user);
  const attemptedRef = useRef(false);

  useEffect(() => {
    if (attemptedRef.current) {
      return;
    }
    attemptedRef.current = true;

    (async () => {
      try {
        const me = await authService.getCurrentUser();
        const redirectUrl = me.redirectUrl || '/';
        await navigateAfterAuth(redirectUrl, {
          isPartners: true,
          navigate,
          roleId: me.user?.roleId ?? user?.roleId,
        });
      } catch {
        attemptedRef.current = false;
      }
    })();
  }, [navigate, user?.roleId]);

  return (
    <div style={{ padding: '48px 24px', textAlign: 'center', color: '#6b7280' }}>
      Loading…
    </div>
  );
};

/**
 * Main-domain home: any signed-in user goes to the guest restaurant listing.
 * Partners subdomain: sign-in gate and partner/staff landing.
 */
const CustomerHomeGate: React.FC = () => {
  const { user, isAuthenticated, authReady } = useAppSelector((state) => state.user);

  if (!authReady) {
    return (
      <div style={{ padding: '48px 24px', textAlign: 'center', color: '#6b7280' }}>
        Loading…
      </div>
    );
  }

  if (isPartnersHost()) {
    if (!isAuthenticated) {
      return <Navigate to="/signin" replace />;
    }
    return <PartnersHomeRedirect />;
  }

  if (isAuthenticated && user) {
    return <Navigate to={CUSTOMER_HOME_PATH} replace />;
  }

  return <MarketingRedirect to="/" />;
};

export default CustomerHomeGate;
